var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts";
import { Box, Center, Text, useSlotRecipe, IconButton } from "@chakra-ui/react";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { AnchorLink } from "@/components/LinkComponents/AnchorLink";
export var TopBanner = function () {
    var _a = React.useState(true), isTopBannerVisible = _a[0], setIsTopBannerVisible = _a[1];
    var properties = useContext(GlobalContext).properties;
    var recipe = useSlotRecipe({ key: "TopBanner" });
    var recipeProps = recipe.splitVariantProps({})[0];
    var styles = recipe(recipeProps);
    var topBannerLink = _jsx(AnchorLink, { anchor: "TopBanner", variant: "topBanner" });
    if (!topBannerLink) {
        return null;
    }
    if (!isTopBannerVisible) {
        return null;
    }
    return (_jsxs(Center, __assign({ css: styles.wrapper, id: "top-banner" }, { children: [_jsxs(Box, { children: [_jsxs(Text, __assign({ as: "b" }, { children: ["Welcome to ", properties.name, " powered by Indeed."] })), "\u00A0 A dedicated space for developers and technologists to find their next job.\u00A0", topBannerLink] }), _jsx(IconButton, __assign({ size: "xs", css: styles.closeBtn, tabIndex: 0, role: "link", "aria-label": "Press to close the top banner", onClick: function () {
                    setIsTopBannerVisible(false);
                } }, { children: _jsx(FontAwesomeIcon, { icon: faXmark }) }))] })));
};
